<template>
<!-- Period choose -->
<!-- <pick-period-vidget
	class="py-2"
	:tiles="new Array(
		['30 днів', 30],
		['90 днів', 90],
		['6 міс', 180],
		['1 рік', 365])"
	@value="(v) => viewDaysFromNow = v"
/> -->
<easy-data-table
	class="data-table mt-1"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:rows-items="[100,200,400,1000,tableItems.length > 1000 ? tableItems.length : 2000]"
	:rows-per-page="100"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="tableHeight"
	:loading="isLoading"
	alternating
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів історії змін не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToString(time, false) }}
	</template>

	<!-- Changes item customization -->
	<template #item-changes="{ changes, diff, passport }">
		<!-- {{ changes }} <br/> -->
		<template v-if="changes == '' && !diff">
			Початок фіксації історії змін
		</template>
		<template v-if="changes == '' && diff">
			<template v-for="(setting, index) in Object.entries(diff)" :key="index">
				<span v-if="parseValue(setting[1].newValue) !== 'не задано'">
					<span class="fst-italic text-decoration-underline">
						{{ settingName(setting[0]) }}
					</span>
					&nbsp;{{ parseValue(setting[1].oldValue) }} -> {{ parseValue(setting[1].newValue) }}<br/>
				</span>
			</template>
			<!-- {{ diff }} -->
		</template>
		<template v-if="changes != ''">
			<span class="fw-semibold">{{ changes }}</span><br/>
			<template v-for="(setting, index) in Object.entries(passport)" :key="index">
				<span v-if="
					![
						...Object.values(FIELD_NAMES),
						Post.passportKeys.metricsId,
						Post.passportKeys.creatorId, 
						Post.passportKeys.isRegistered,
						Post.passportKeys.notificationDistributionLists.self,
					].includes(setting[0])"
				>
					<span class="fst-italic text-decoration-underline">
						{{ Post.settingNames[setting[0]] ? Post.settingNames[setting[0]] : setting[0] }}
					</span>
					&nbsp;{{ parseValue(setting[1]) }}<br>
				</span>
			</template>
		</template>
		<!-- {{ changes == '' ?  passport : changes }} -->
	</template>

</easy-data-table>
</template>


<script>
import {
	// subtractHoursFromNowDate,
	dateTimeToString,
	// fixNumberPrecision,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
	getObjectDiff,
} from '@/helpers.js'
// import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { usePostsStore } from '@/stores/PostsStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Post } from '@/models/post.js'
import { FIELD_NAMES, parseApiTimeDate } from '@/api/api.js'

export default {
	components: {
		// PickPeriodVidget,
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			postsStore,
			stationsStore,
			Post,
			FIELD_NAMES,
			dateTimeToString,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
			getObjectDiff,
		}
	},

	data() {
		return {
			// For table period from. Hours from now.
			viewDaysFromNow: 30,
			isLoading: true,
			// Table
			rowsPerPage: 20,
			tableHeaders:[
				{ text: "Час", value: "time", sortable: true, },
				{ text: "Користувач", value: "actor",  },
				{ text: "Зміни відносно попереднього", value: "changes" },
			],

			tableItems: [],
		}
	},

	async created() {
		await this.stationsStore.readStations()

		this.readTableData()

		this.$watch(() => this.viewDaysFromNow, (/*newVal, oldVal*/) => {
			// Update last activity timestamp
			this.readTableData()
		})
	},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage(this.tableHeight)
	},

	methods: {
		async readTableData() {
			this.isLoading = true

			const ret = await this.postsStore.postPasportHistory(this.postId)

			this.tableItems.length = 0
			this.isLoading = false
			let prevRecord = undefined

			ret.forEach((record) => {
				// console.log("Table row raw", record)

				record[Post.passportKeys.orgId] = record[Post.passportKeys.orgId][this.accountStore.schema.organization.title]
				if (record[Post.passportKeys.relatedStations]) {
					let stationNames = ''
					for (const stationId of record[Post.passportKeys.relatedStations]) {
						// console.log(this.stationsStore.station(stationId))
						if (stationNames != '') {
							stationNames +=	', '
						}
						stationNames += '"' + this.stationsStore.station(stationId).passport.get('name') + '"'
					}

					record[Post.passportKeys.relatedStations] = stationNames
				}

				let actor = '-'
				let changes = ''
				let diff = null

				// If record was updated
				if (record[Post.passportKeys.updateBy]) {
					actor = record[Post.passportKeys.updateBy][this.accountStore.schema.name]
				// Else means record created
				} else {
					actor = record[Post.passportKeys.creatorId][this.accountStore.schema.name]
					changes = 'КВП створено'
				}

				if (record && prevRecord) {
					diff = getObjectDiff(prevRecord, record)
					for (const key of Object.values(FIELD_NAMES)) {
						delete diff[key]
					}

					delete diff[Post.passportKeys.updateBy]
					delete diff[Post.passportKeys.creatorId]
				}

				this.tableItems.push({
					time: parseApiTimeDate(record[FIELD_NAMES.updateTime]),
					actor: actor,
					changes: changes,
					passport: record,
					diff: diff,
				})

				prevRecord = record
			})
		},

		settingName(settingId) {
			if (settingId == Post.passportKeys.departmentId) {
				return this.accountStore.organization.department_title ? 
					this.accountStore.organization.department_title :
					Post.departmentDefaultTitle
			} else if (settingId == Post.passportKeys.sectorId) {
				return this.accountStore.organization.sector_title ? 
					this.accountStore.organization.sector_title :
					Post.sectorIdDefaultTitle
			} else if (Post.settingNames[settingId]) {
				return Post.settingNames[settingId]
			} else {
				return settingId
			}
		},

		departmentName(departmentId) {
			const department = this.departments.find((el) => el.id == departmentId)
			return department ? department[this.accountStore.schema.organization.departments.title] : null
		},

		sectorName(sectorId) {
			let name = null
			for (const department of this.departments) {
				for (const sector of department[this.accountStore.schema.organization.departments.sectors]) {
					if (sector.id == sectorId) {
						name = sector.title
					}
				}
			}
			return name
		},

		parseValue(value) {
			if (Object.prototype.toString.call(value) === '[object Date]') {
				return dateTimeToString(value)
			} else if (value === true || value === false) {
				return value ? 'так' : 'ні'
			} else if (this.departmentName(value)) {
				return this.departmentName(value)
			} else if (this.sectorName(value)) {
				return this.sectorName(value)
			} else if (Object.prototype.toString.call(Post.postControlType[value]) == '[object Object]') {
				return Post.postControlType[value].title
			} else if (value === null || value === undefined || value == '') {
				return 'не задано'
			} else {
				return value
			}
		},
	},

	computed: {
		post() {return this.postsStore.post(this.postId); },

		tableHeight() { return easyDataTableHeight() },

		postOrg() {
			return this.post.passport.get(Post.passportKeys.org)
		},

		departments() {
			const org = this.postOrg
			if (!org) {
				return []
			}

			const deps = org.departments
			if (!deps) {
				return []
			}

			return deps
		},
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>
</style>